import "./style.scss";

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import type { AccountingMapping } from "store/types";

import MappingLine from "./MappingLine";

interface AccountingMappingTable {
    mapping: AccountingMapping[];
    valueTypeList: Array<{ id: string; label: string }>;
    AccountingAccountCategories: string[];
    handleMappingDeletion: (line: AccountingMapping, appearanceOrder: number) => void;
    handleMappingValueChange: <K extends keyof AccountingMapping>(key: K, index: number, value: any) => void;
    filterMapping?: (line: AccountingMapping) => boolean;
}

const AccountingMappingTable = ({
    mapping,
    valueTypeList,
    handleMappingDeletion,
    handleMappingValueChange,
    filterMapping,
}: AccountingMappingTable) => {
    const [t] = useTranslation();

    return (
        <div className="accounting-mapping-table">
            <TableContainer>
                <Table>
                    <TableHead className="table-head">
                        <TableRow className="head-row">
                            <TableCell className="head-cell">{t("Accounting.JournalCode")}</TableCell>
                            <TableCell className="head-cell">{t("Accounting.AccountNumber")}</TableCell>
                            <TableCell className="head-cell">{t("Accounting.MappingValue")}</TableCell>
                            <TableCell className="head-cell">{t("Accounting.Direction")}</TableCell>
                            <TableCell className="head-cell">{t("Accounting.AccountCategory")}</TableCell>
                            <TableCell className="head-cell">{t("Accounting.AttachAuxiliaryCode")}</TableCell>
                            <TableCell className="head-cell"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody className="table-body">
                        {mapping.map((_mapping, idx: number) =>
                            !filterMapping || filterMapping(_mapping) ? (
                                <MappingLine
                                    line={_mapping}
                                    idx={idx}
                                    handleMappingDeletion={handleMappingDeletion}
                                    handleMappingValueChange={handleMappingValueChange}
                                    key={_mapping.id}
                                    valueTypeList={valueTypeList}
                                />
                            ) : null,
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default memo(AccountingMappingTable);
